var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('vue-title', {
    attrs: {
      "title": "Reset your password - Your Indoor Cycling Solution"
    }
  }), _c('section', {
    staticClass: "login-wrap mt-5"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col-xl-6 col-lg-7 col-md-9 mx-auto"
  }, [_c('div', {
    staticClass: "login-box"
  }, [_c('h3', [_vm._v("Reset your password")]), _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.submitHandler();
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("New Password")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.password,
      expression: "form.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "password",
      "placeholder": "Enter new password",
      "autocomplete": "chrome-off"
    },
    domProps: {
      "value": _vm.form.password
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password", $event.target.value);
      }
    }
  }), _vm.submitted && _vm.getError('password') ? _c('div', {
    staticClass: "text-danger text-left"
  }, [_vm._v("Password must be at least 6 characters")]) : _vm._e()]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Confirm New Password")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.repeatPassword,
      expression: "form.repeatPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "cpassword",
      "placeholder": "Repeat new password",
      "autocomplete": "chrome-off"
    },
    domProps: {
      "value": _vm.form.repeatPassword
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "repeatPassword", $event.target.value);
      }
    }
  }), _vm.submitted && _vm.getError('repeatPassword') ? _c('div', {
    staticClass: "text-danger text-left"
  }, [_vm._v("Password doesn't match")]) : _vm._e()]), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _c('button', {
    staticClass: "btn-universal cursor-pointer",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")])])])])])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }